export default "__VITE_ASSET__0wU6QppA__"